import { clickToOpenMegaNav } from './clickToOpenMegaNav';
import { clickToEraseSearch } from './clickToEraseSearch';

const headerInit = () => {
  clickToOpenMegaNav();
  clickToEraseSearch();
};

export default headerInit;
